// src/graphql/mutations/userMutations.js

export const createUser = `mutation CreateUser($input: RegisterInput!) {
    createUser(input: $input) {
        success
        message
        user {
            id
            email
            firstName
            lastName
            role
        }
        error
    }
}`;

export const updateUser = `mutation UpdateUser($id: String!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
        success
        message
        user {
            id
            email
            firstName
            lastName
            role
            active
        }
        error
    }
}`;

export const deleteUser = `mutation DeleteUser($id: String!) {
    deleteUser(id: $id) {
        success
        message
        error
    }
}`;

export const setCompanyRepresentative = `mutation SetCompanyRepresentative($userId: String!, $companyId: String!) {
    setCompanyRepresentative(userId: $userId, companyId: $companyId) {
        success
        error
    }
}`;

// Admin support actions
export const adminResendVerificationEmail = `mutation AdminResendVerificationEmail($userId: String!) {
    adminResendVerificationEmail(userId: $userId) {
        success
        message
        error
    }
}`;

export const adminResendPasswordResetEmail = `mutation AdminResendPasswordResetEmail($userId: String!) {
    adminResendPasswordResetEmail(userId: $userId) {
        success
        message
        error
    }
}`;

export const adminResendRegistrationEmail = `mutation AdminResendRegistrationEmail($userId: String!) {
    adminResendRegistrationEmail(userId: $userId) {
        success
        message
        error
    }
}`;

export const adminSetUserVerified = `mutation AdminSetUserVerified($userId: String!) {
    adminSetUserVerified(userId: $userId) {
        success
        message
        error
    }
}`;

export const adminSetUserPassword = `mutation AdminSetUserPassword($userId: String!, $newPassword: String!) {
    adminSetUserPassword(userId: $userId, newPassword: $newPassword) {
        success
        message
        error
    }
}`;

// Impersonation. Field selection must match ImpersonationResult exactly:
// a stale selection (the old "user" field) made the whole mutation fail
// GraphQL validation, which ImpersonationContext interpreted as "backend
// doesn't support impersonation" — silently disabling the feature.
export const adminImpersonateUser = `mutation AdminImpersonateUser($userId: String!) {
    adminImpersonateUser(userId: $userId) {
        success
        message
        impersonatedUser {
            id
            email
            firstName
            lastName
            role
        }
        token
        impersonationInfo {
            isImpersonation
            impersonatedBy {
                id
                email
                firstName
                lastName
            }
        }
        error
    }
}`;

export const endImpersonation = `mutation EndImpersonation {
    endImpersonation {
        success
        message
        error
    }
}`;


// One-step agency account: role SALES, pre-verified, company without a trial
// subscription, zero events/mails. The password is transmitted out of band.
export const createSalesUser = `mutation CreateSalesUser($input: RegisterInput!) {
    createSalesUser(input: $input) {
        success
        message
        error
        user {
            id
            email
            role
        }
    }
}`;
